var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNounGolf1825195(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    viewBox: "0 0 32 32",
    x: "0px",
    y: "0px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Amenities flat") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17,21v-9.4l7.44-3.69a1,1,0,0,0,0-1.79l-8-4h0A1,1,0,0,0,16.23,2,1,1,0,0,0,16,2h0l-.13,0a1,1,0,0,0-.22,0,1,1,0,0,0-.16.09,1,1,0,0,0-.16.11,1,1,0,0,0-.13.17.94.94,0,0,0-.09.11v0a1,1,0,0,0-.05.2A1,1,0,0,0,15,3s0,0,0,0V25a1,1,0,0,0,2,0V23c4.54.19,7,1.69,7,2.48S21.18,28,16,28s-8-1.65-8-2.5c0-.56,1.3-1.6,4.19-2.16a1,1,0,0,0-.38-2C8.17,22.08,6,23.62,6,25.5c0,3,5,4.5,10,4.5s10-1.55,10-4.5C26,22.74,21.62,21.22,17,21Zm0-16.4L21.76,7,17,9.39Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNounGolf1825195);
export default __webpack_public_path__ + "static/media/noun-golf-1825195.bacde68ab1f2da6e6325f5dc0913fc48.svg";
export { ForwardRef as ReactComponent };